import React, { useEffect } from "react";
import Slider from "react-slick";
import { useSelector, useDispatch } from "react-redux";
import { fetchBanners } from "../../features/bannerSlice";
import { Link } from "react-router-dom";

function Banner() {
  const dispatch = useDispatch();
  const { banners, status, error } = useSelector((state) => state.banner);

  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    fade: true,
    lazyLoad: "ondemand",
  };

  useEffect(() => {
    if (status === "idle") {
      // Fetch banners and store them in sessionStorage
      dispatch(fetchBanners());
    }
  }, [dispatch, status]);

  const fetchLinks = (item) => {
    if (item.product_id) {
      return `/product-details/${item.product_id}`;
    } else if (item.subchildcategory_id) {
      return `/subchildcategory/${item.subchildcategory_id}`;
    } else if (item.subcategory_id) {
      return `/subcategory/${item.subcategory_id}`;
    } else if (item.category_id) {
      return `/category/${item.category_id}`;
    } else if (item.classification_id) {
      return `/classification_list/${item.classification_id}`;
    }
  };

  return (
    <div className="banner_section_main">
      <Slider {...settings}>
        {banners.length > 0 &&
          banners.map((item, index) => (
            <div key={index} className="banner-slide">
              <Link to={fetchLinks(item)}>
                <img
                  src={item.banner_img}
                  alt={item.banner_title}
                  className="carousel-image"
                />
              </Link>
            </div>
          ))}
      </Slider>
    </div>
  );
}

export default Banner;
